function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { SHAPES } from './Icon';
import ColorPicker from './ColorPicker';
import '../css/libstyle.css';
import { libstyle } from './styleParser';
var defaultValues = {
  border: 0,
  size: 60
};

var IconConfigurator = function (_Component) {
  _inherits(IconConfigurator, _Component);

  function IconConfigurator(props) {
    _classCallCheck(this, IconConfigurator);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      primaryColor: undefined,
      secondaryColor: undefined,
      inverted: false,
      border: defaultValues.border,
      size: defaultValues.size,
      shape: undefined,
      defaultBorder: true,
      defaultSize: true
    };

    if (props.configuredIcon) {
      var configuredIcon = props.configuredIcon;
      var shape = configuredIcon.shape;

      if (shape === undefined) {
        shape = 'none';
      }

      var border = configuredIcon.border;
      var defaultBorder = false;

      if (border === undefined) {
        defaultBorder = true;
        border = defaultValues.border;
      }

      var size = configuredIcon.size;
      var defaultSize = false;

      if (size === undefined) {
        defaultSize = true;
        size = defaultValues.size;
      }

      _this.state.defaultBorder = defaultBorder;
      _this.state.defaultSize = defaultSize;
      _this.state.primaryColor = configuredIcon.primaryColor;
      _this.state.secondaryColor = configuredIcon.secondaryColor;
      _this.state.shape = shape;
      _this.state.border = border;
      _this.state.size = size;
      _this.state.inverted = configuredIcon.inverted;
      _this.state.configuredIcon = configuredIcon;
    }

    _this.handlePrimaryColorChange = _this.handlePrimaryColorChange.bind(_this);
    _this.handleSecondaryColorChange = _this.handleSecondaryColorChange.bind(_this);
    _this.handleInvertedChange = _this.handleInvertedChange.bind(_this);
    _this.handleBorderChange = _this.handleBorderChange.bind(_this);
    _this.handleShapeChange = _this.handleShapeChange.bind(_this);
    _this.handleSizeChange = _this.handleSizeChange.bind(_this);
    _this.handleDefaultBorderChange = _this.handleDefaultBorderChange.bind(_this);
    _this.handleDefaultSizeChange = _this.handleDefaultSizeChange.bind(_this);
    _this.handleIconChange = _this.handleIconChange.bind(_this);
    _this.isNew = _this.isNew.bind(_this);
    _this.retrievePreviousConfiguration = _this.retrievePreviousConfiguration.bind(_this);
    return _this;
  }

  IconConfigurator.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.configuredIcon && this.isNew(nextProps.configuredIcon)) {
      this.retrievePreviousConfiguration(nextProps.configuredIcon);
    }

    if (this.props.iconName !== nextProps.iconName) {
      this.handleIconChange(nextProps.iconName);
    }
  };

  IconConfigurator.prototype.isNew = function isNew(newConfiguration) {
    if (newConfiguration.border !== this.state.configuredIcon.border) return true;
    if (newConfiguration.inverted !== this.state.configuredIcon.inverted) return true;
    if (newConfiguration.name !== this.state.configuredIcon.name) return true;
    if (newConfiguration.padding !== this.state.configuredIcon.padding) return true;
    if (newConfiguration.primaryColor !== this.state.configuredIcon.primaryColor) return true;
    if (newConfiguration.secondaryColor !== this.state.configuredIcon.secondaryColor) return true;
    if (newConfiguration.shape !== this.state.configuredIcon.shape) return true;
    if (newConfiguration.size !== this.state.configuredIcon.size) return true;
    return false;
  };

  IconConfigurator.prototype.retrievePreviousConfiguration = function retrievePreviousConfiguration(configuredIcon) {
    var shape = configuredIcon.shape;

    if (shape === undefined) {
      shape = 'none';
    }

    var border = configuredIcon.border;
    var defaultBorder = false;

    if (border === undefined) {
      defaultBorder = true;
      border = defaultValues.border;
    }

    var size = configuredIcon.size;
    var defaultSize = false;

    if (size === undefined) {
      defaultSize = true;
      size = defaultValues.size;
    }

    this.setState({
      defaultBorder: defaultBorder,
      defaultSize: defaultSize,
      primaryColor: configuredIcon.primaryColor,
      secondaryColor: configuredIcon.secondaryColor,
      shape: shape,
      border: border,
      size: size,
      inverted: configuredIcon.inverted,
      configuredIcon: configuredIcon
    });
  };

  IconConfigurator.prototype.handlePrimaryColorChange = function handlePrimaryColorChange(color) {
    this.setState({
      primaryColor: color
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleSecondaryColorChange = function handleSecondaryColorChange(color) {
    this.setState({
      secondaryColor: color
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleInvertedChange = function handleInvertedChange(evt) {
    var checked = evt.target.checked;
    this.setState({
      inverted: checked
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleBorderChange = function handleBorderChange(evt) {
    var border = parseInt(evt.target.value);
    this.setState({
      border: border
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleSizeChange = function handleSizeChange(evt) {
    var size = evt.target.value;
    this.setState({
      size: size
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleShapeChange = function handleShapeChange(evt) {
    var shape = evt.target.value;
    this.setState({
      shape: shape
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleDefaultBorderChange = function handleDefaultBorderChange(evt) {
    var defaultBorder = evt.target.checked;
    var border = this.state.border;

    if (defaultBorder) {
      border = defaultValues.border;
    }

    this.setState({
      defaultBorder: defaultBorder,
      border: border
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleDefaultSizeChange = function handleDefaultSizeChange(evt) {
    var defaultSize = evt.target.checked;
    var size = this.state.size;

    if (defaultSize) {
      size = defaultValues.size;
    }

    this.setState({
      defaultSize: defaultSize,
      size: size
    }, this.handleIconChange);
  };

  IconConfigurator.prototype.handleIconChange = function handleIconChange(newName) {
    if (this.props.handleIconChange) {
      var secondaryColor = this.state.secondaryColor;
      var shape = this.state.shape;

      if (this.state.shape === 'none') {
        secondaryColor = undefined;
        shape = undefined;
      }

      var border = this.state.border;

      if (this.state.defaultBorder === true) {
        border = undefined;
      }

      var size = this.state.size;

      if (this.state.defaultSize === true) {
        size = undefined;
      } else {
        size = size + 'px';
      }

      var name = this.props.iconName;

      if (newName) {
        name = newName;
      }

      var iconConfig = {
        name: name,
        inverted: this.state.inverted,
        primaryColor: this.state.primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        shape: shape,
        border: border,
        padding: 5
      };
      this.props.handleIconChange(iconConfig);
    }
  };

  IconConfigurator.prototype.render = function render() {
    return React.createElement('div', null, React.createElement('div', {
      className: libstyle.configuratorItem
    }, React.createElement('span', {
      className: libstyle.configuratorItemTitle
    }, 'Inverted'), React.createElement('input', {
      type: 'checkbox',
      checked: this.state.inverted,
      onChange: this.handleInvertedChange
    })), React.createElement('div', {
      className: libstyle.configuratorItem
    }, React.createElement('span', {
      className: libstyle.configuratorItemTitle
    }, 'Border'), React.createElement('input', {
      type: 'range',
      min: '0',
      max: '15',
      value: this.state.border,
      onChange: this.handleBorderChange,
      disabled: this.state.defaultBorder
    }), React.createElement('input', {
      type: 'checkbox',
      onChange: this.handleDefaultBorderChange,
      checked: this.state.defaultBorder
    }), 'Default values'), this.props.hideSize === true ? '' : React.createElement('div', {
      className: libstyle.configuratorItem
    }, React.createElement('span', {
      className: libstyle.configuratorItemTitle
    }, 'Size'), React.createElement('input', {
      type: 'range',
      min: '5',
      max: '200',
      step: '5',
      value: this.state.size,
      onChange: this.handleSizeChange,
      disabled: this.state.defaultSize
    }), React.createElement('input', {
      type: 'checkbox',
      onChange: this.handleDefaultSizeChange,
      checked: this.state.defaultSize
    }), 'Default values'), React.createElement('div', {
      className: libstyle.configuratorItem
    }, React.createElement('span', {
      className: libstyle.configuratorItemTitle
    }, 'Shape'), React.createElement('select', {
      onChange: this.handleShapeChange,
      value: this.state.shape
    }, React.createElement('option', {
      key: 'none',
      value: 'none'
    }, 'none'), Object.keys(SHAPES).map(function (currKey) {
      return React.createElement('option', {
        key: currKey,
        value: SHAPES[currKey]
      }, currKey);
    }))), React.createElement('div', {
      className: libstyle.configuratorItem
    }, React.createElement('span', {
      className: libstyle.configuratorItemTitle
    }, 'Preview'), React.createElement('div', null, React.createElement('div', {
      className: libstyle.inlineContainer
    }, React.createElement(ColorPicker, {
      handleColorChange: this.handlePrimaryColorChange,
      color: this.props.primaryColor ? this.props.primaryColor : '#000'
    }), React.createElement(ColorPicker, {
      handleColorChange: this.handleSecondaryColorChange,
      color: this.props.secondaryColor ? this.props.secondaryColor : '#c6c6c6'
    })), this.props.hidePreview ? '' : React.createElement('div', {
      className: libstyle.inlineContainer
    }, this.props.iconName ? React.createElement(Icon, {
      name: this.props.iconName,
      inverted: this.state.inverted,
      primaryColor: this.state.primaryColor,
      secondaryColor: this.state.secondaryColor //preview és size-independent
      ,
      size: this.state.size + 'px',
      shape: this.state.shape,
      border: this.state.border != 0 ? this.state.border : undefined,
      padding: 5
    }) : ''))));
  };

  return IconConfigurator;
}(Component);

IconConfigurator.propTypes = process.env.NODE_ENV !== "production" ? {
  iconName: PropTypes.string,
  hidePreview: PropTypes.bool,
  handleIconChange: PropTypes.func,
  configuredIcon: PropTypes.object,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  hideSize: PropTypes.bool
} : {};
export default IconConfigurator;